/**
 * Pause button
 */
(() => {
    let buttons = document.querySelectorAll('.js-pause-button');

    if (!buttons.length) {
        return;
    }

    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            // console.log('Pause button clicked');

            let text = button.querySelector('.js-pause-button-text');
            let wrapper = button.closest('.js-pause-button-video-wrapper');

            if (!text || !wrapper) {
                return;
            }

            let video = wrapper.querySelector('.js-pause-button-video');

            if (!video) {
                // console.log('... Video not found');
                return;
            }

            if (video.paused) {
                video.play();
                text.innerText = button.getAttribute('data-text-pause');
                button.classList.remove('-paused');
                button.classList.add('-playing');
            } else {
                video.pause();
                text.innerText = button.getAttribute('data-text-play');
                button.classList.remove('-playing');
                button.classList.add('-paused');
            }
        });
    });
})();
